import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { CompetencyCode } from "../../entities/competency-code";

@Injectable()
export class CompetencyCodeRepo extends Repository<CompetencyCode>{
    constructor(private dataSource: DataSource) {
        super(CompetencyCode, dataSource.createEntityManager());
    }
}
